import { Slot } from "@radix-ui/react-slot";
import { twMerge } from "tailwind-merge";

import { Tooltip } from "../Tooltip";

import { Container, Button, TipContent } from "./styles";

export function ActionRoot({
  children,
  asChild,
  title,
  className,
  name = false,
  download = false,
  isLoading = false,
  ...rest
}) {
  const El = asChild ? Slot : "button";
  let clickAction = () => null;

  if (isLoading) rest.disabled = true;

  const downloadAction = () => {
    if (!download.path) return;

    const link = document.createElement("a");

    link.href = `${download.path}?t=${new Date().getTime()}`;
    link.download = download.name || "downloaded_file";

    console.log('download link', link.href);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!!download) clickAction = downloadAction;

  return (
    <Container>
      {!!name && !!title && (
        <Tooltip.Root name={name} side="top" sideOffset={26} zIndex={112}>
          <TipContent>{title}</TipContent>
        </Tooltip.Root>
      )}
      <Tooltip.Trigger tooltipName={name} asChild>
        <Button as={El} onClick={clickAction} {...rest} className={twMerge("group/ui-action", className)}>
          {children}
        </Button>
      </Tooltip.Trigger>
    </Container>
  );
}
